module.exports = __webpack_public_path__ + "img/status-bar-lit.fbd9074b.svg";